export function getPageReferer() {
  // both methods are valid
  return document.referrer;
  // return encodeURIComponent(document.referrer) || escape(document.referrer);
}
